import { AbstractControl } from "@angular/forms";

export function enableOrDisableCtrl(enable: boolean, control: AbstractControl) {
    if (enable) {
        control.enable()
    } else {
        control.disable()
    }
}
